
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.831 14.313c-.084.413-.301.676-.596.81-.24.108-.52.117-.81.04a2.24 2.24 0 01-.767-.395c-.684-.522-1.321-1.5-1.396-2.72a8.114 8.114 0 01.025-1.2c.025-.282.064-.577.115-.884L2.48 9.946l-.013-.001a3.188 3.188 0 01-1.32-.342 2.151 2.151 0 01-.81-.712 1.79 1.79 0 01-.29-1.082 2.52 2.52 0 01.271-.994c-.094-.4-.137-.83-.072-1.206.055-.32.183-.603.41-.814-.009-.528.066-.971.212-1.354.15-.394.373-.72.66-1.008.026-.253.068-.495.134-.72a2.45 2.45 0 01.37-.774c.502-.692.9-.674 1.531-.644.088.004.182.009.328.01L9.608.34c.514.003.918.08 1.286.264.364.183.674.463 1.004.877l.084.24-.04 6.594-.291.075c-.738.192-1.322.812-1.778 1.555-.467.765-.798 1.662-1.025 2.386l-.012 1.908-.005.074zm8.621-5.275l-4.26-.026a.584.584 0 01-.582-.583l.047-7.704a.584.584 0 01.59-.576l4.26.026a.584.584 0 01.582.583l-.047 7.704a.585.585 0 01-.59.576z","fill":"red"}})])
          )
        }
      }
    